import React from 'react';
import { UtensilsCrossed } from 'lucide-react';
import MealSlotAddButton from './MealSlotAddButton';

/**
 * Meal-types-first layout: one row per option for the selected meal type.
 * The slot editor renders its own row (summary card + recipes); `summary`
 * carries the card data.
 */
export default function MealSlotMealTypesFirstRows({
  selectedMealType,
  optionNumbers = [],
  getRowMeta,
  renderSlotEditor,
  onAddClick,
  addButtonTitle = 'Add option',
  showAddButton = false,
}) {
  if (optionNumbers.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-12 text-center">
        <UtensilsCrossed className="w-12 h-12 text-gray-300 mx-auto mb-4" />
        <p className="text-gray-500 mb-4">No options for {selectedMealType}</p>
      </div>
    );
  }

  return (
    <div className="space-y-0">
      {optionNumbers.map((optNum) => {
        const { itemCount, caloriesLabel, macros } = getRowMeta(optNum);
        return (
          <React.Fragment key={optNum}>
            {renderSlotEditor(optNum, {
              title: `Option ${optNum}`,
              itemCount,
              caloriesLabel,
              macros,
            })}
          </React.Fragment>
        );
      })}
      {showAddButton && onAddClick && (
        <MealSlotAddButton onClick={onAddClick} title={addButtonTitle} />
      )}
    </div>
  );
}
